import moment from 'moment';
export function utcDateTimeToLocal(date) {
  if (!date) {
    return '-';
  }

  return moment(date).format('YYYY-MM-DD HH:mm:ss');
}
export function utcDateTimeToDate(date) {
  if (!date) {
    return '-';
  }

  return moment(date).format('YYYY-MM-DD ');
}
export function formatDate(date) {
  if (!date) {
    return '-';
  }

  return moment(date).format('YYYY-MM-DD');
}
export function formatWeixinDate(date) {
  if (!date) {
    return '-';
  }

  return moment(date, 'YYYYMMDDhhmmss').format('YYYY-MM-DD HH:mm:ss');
}